import React from 'react';

import { Box, CircularProgress } from '@mui/material';
import clsx from 'clsx';

import { ILoaderProps } from './types';

import styles from './Loader.module.scss';

export const Loader: React.FC<ILoaderProps> = ({ className, ...props }) => (
  <Box className={clsx(styles.loader, className)}>
    <CircularProgress {...props} />
  </Box>
);
